import * as React from "react";
import { Box, Grid, IconButton, Switch, Typography } from "@mui/material";
import batchingplant from "../Images/Machines/Batching plant.png";
import excavator from "../Images/Machines/excavator.png";
import Navbar2 from "../Navbar/Navbar2";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import MachineListTable from "../Modal/MachineListTable";
import CloseIcon from "@mui/icons-material/Close";
import MachineListMap from "./MachineListMap";
import axios from "axios";

// sample icon list (replace src with your actual SVG/PNG)
const applications = [
  { title: "Batching Plant", icon: batchingplant },
  // { title: "Excavator", icon: excavator },
  // { title: "Excavator", icon: excavator },
  // { title: "Excavator", icon: excavator },
  // { title: "Excavator", icon: excavator },
  // { title: "Excavator", icon: excavator },
];

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 7,
  p: 4,

  // IMPORTANT
  border: "none",
  outline: "none",
};

export default function MachineList() {
  const [open, setOpen] = React.useState(false);
  const [machineList, setMachineList] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleMachineView = (id) => {
    setMachineList(id);
  };

  return (
    <div>
      <Navbar2 />
      {machineList == false ? (
        <Box
          sx={{
            px: { xs: 2, md: 6 },
            py: 5,
          }}
        >
          {/* Title */}
          <Grid sx={{ display: "flex", justifyContent: "space-between" }}>
            <Grid>
              <Typography
                variant='h4'
                sx={{
                  fontWeight: 600,
                  mb: 1,
                  color: "#2e2e2e",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                {sessionStorage.getItem("comp_name")}
              </Typography>
            </Grid>
            <Grid>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  mt: 0.5,
                }}
              >
                <Switch
                  checked={machineList}
                  onChange={(e) => setMachineList(e.target.checked)}
                  size='small'
                  sx={{
                    width: 36,
                    height: 20,
                    padding: 0,

                    "& .MuiSwitch-switchBase": {
                      padding: 0.3,
                      transform: "translateX(0px)",
                    },

                    "& .MuiSwitch-thumb": {
                      width: 16,
                      height: 16,
                    },

                    "& .MuiSwitch-track": {
                      borderRadius: 20,
                      backgroundColor: "#d1d5db",
                      opacity: 1,
                    },

                    "& .MuiSwitch-switchBase.Mui-checked": {
                      transform: "translateX(16px)",
                      color: "#fff",
                    },

                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#0059ff",
                      opacity: 1,
                    },
                  }}
                />

                <Typography
                  sx={{
                    fontFamily: "Poppins, sans-serif",
                    fontSize: "0.7rem",
                  }}
                >
                  {machineList ? "Map" : "List"}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* Description */}
          <Typography
            sx={{
              color: "#555",
              fontSize: 14,
              fontFamily: "Poppins, sans-serif",
            }}
          >
            Oilpower’s manual and electro-hydraulic control valves are designed
            for precision and durability for various mobile equipment.
          </Typography>

          {/* Icons Grid */}
          <Grid container sx={{ paddingLeft: 5, paddingRight: 5 }}>
            {applications.map((item, index) => (
              <Grid
                size={{ lg: 3, xs: 12, md: 12, sm: 12 }}
                key={index}
                textAlign='center'
                onClick={() => {
                  setOpen(true);
                }}
                sx={{ cursor: "pointer" }}
              >
                <Box
                  component='img'
                  src={item.icon}
                  alt={item.title}
                  sx={{
                    width: 200,
                    height: 200,
                    objectFit: "contain",
                  }}
                />

                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#333",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
                  {item.title}
                </Typography>
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : (
        <MachineListMap
          handleMachineView={handleMachineView}
          machineList={machineList}
        />
      )}

      <div>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby='modal-modal-title'
          aria-describedby='modal-modal-description'
        >
          <Box sx={style}>
            <Grid
              sx={{
                position: "absolute", // 👈 stays fixed on screen
                top: 10,
                right: 10,
                cursor: "pointer",
                zIndex: 1000, // ensures it stays above other elements
              }}
            >
              <IconButton
                onClick={() => {
                  setOpen(false);
                }}
              >
                <CloseIcon sx={{ color: "#2e2e2e", fontSize: "1.3rem" }} />
              </IconButton>
            </Grid>
            <MachineListTable />
          </Box>
        </Modal>
      </div>
    </div>
  );
}
